import { type RefObject, createContext, useContext } from "react";

export type AlertDialogAnimationContextValue = RefObject<DOMRect | null>;

export function makeAlertDialogAnimationContext(
  originRef?: AlertDialogAnimationContextValue,
): AlertDialogAnimationContextValue {
  return originRef ?? { current: null };
}

export const AlertDialogAnimationContext =
  createContext<AlertDialogAnimationContextValue>(
    makeAlertDialogAnimationContext(),
  );

export function useAlertDialogAnimationContext() {
  return useContext(AlertDialogAnimationContext);
}
